module.exports = __webpack_public_path__ + "static/img/no-data-card2.abb7ee12.png";